import React from 'react';

import styles from './styles.module.scss';
import {Logs} from './Logs';
import {socialLinks} from '../../constants/links';
import {Label} from '../../components/Labels';

export const ChangeLog = () => {
  return (
    <div className={styles.changeLog}>
      <div className={styles.container}>
        <div className={styles.top}>
          <h1 className={styles.title}>Changelog</h1>
          <p className={styles.subTitle}>
            The latest Themis feature releases, improvements, design updates, and bug fixes.
          </p>
          <div className={styles.bottom}>
            <Label text="Follow us on Twitter 🐦" href={socialLinks.twitter} target="_blank" />
          </div>
        </div>

        <Logs />
      </div>
    </div>
  );
};
